const MediaAcceptanceStatusEnum = {
    AWAITING: 'Awaiting',
    APPROVED: 'Approved',
    REJECTED: 'Rejected'
}

export default MediaAcceptanceStatusEnum;